import React from "react";
import { withStyles } from '@material-ui/core/styles';
import { get } from 'lodash';
import { FormattedMessage } from 'react-intl';


const CollegeDegree = ({ classes, user, obfuscateView }) => {
  if (user) {
    return (
      <div className={classes.status}>
        <strong><FormattedMessage id="profile_page.college_degree"/></strong>
        {!obfuscateView && <p>{get(user, 'college_degree')}</p>}
        {obfuscateView && <p className="blurry-text">???</p>}
      </div>
    );
  }
  return <div />;
}

const styles = {
  status : {
    marginBottom : 15,
    width        : 170,
  },
};

export default withStyles(styles)(CollegeDegree);